import { RecoverableBinding, recoverableField } from "../../../ServiceDesk/recovery/recoverable-control";
import { CustomKeyValues } from "../../logger/telemetry-service";

export class CheckboxBinding extends RecoverableBinding {
  /** Bound value for whether or not the checkbox should be disabled. */
  public isDisabled = "<?";

  /** The string label for this textbox. Will show up as text if transclusion is not used.*/
  public label = "@";

  /** The value this checkbox will be bound to. */
  public value = "=";

  /** Callback function for changed values. This is a callback supporting one argument: { value: boolean }. The item property is still included in this callback but is deprecated. */
  public onChange = "&?";

  /** The identifier for all business intelligence (BI) actions triggered by this component.*/
  public biId = "@?";

  public telemetryData = "<?";

  public scenario = "<?";
}

// TODO: Should this be a separate control (probably not)? If not, we need to add some additional hooks in for 'related' bindings.
export class CheckboxGroupBinding {
  /** The layout for the checkbox group. "horizontal" will result in a horizontal layout, anything else will be vertical. */
  public layout = "@?";
}

/** Controller for Checkbox component. */
export class CheckboxController {
  public isDisabled: boolean;
  public label: string;
  @recoverableField
  public value: any;
  public biId: any;
  public telemetryData: CustomKeyValues;
  public scenario: string;
  public scenarioStep: string;

  // Note: 'item' property is still here for backwards compatibility.
  public onChange: (args: { item: boolean; value: boolean }) => void;

  public $onInit() {
    if (this.scenario) {
      this.scenarioStep = this.scenario + ".CheckBox";
    }
    this.refreshView();
  }

  public $onChanges() {
    this.refreshView();
  }

  private refreshView() {
    this.isDisabled = this.isDisabled === true;
  }

  $sdRecoveryOnComplete() {
    this.onChanged();
  }

  public onChanged() {
    if (angular.isFunction(this.onChange)) {
      // Note: 'item' property is still here for backwards compatibility.
      this.onChange({ item: this.value, value: this.value });
    }
  }

  public getBIName() {
    return `${this.label}: ${this.value ? "checked" : "unchecked"}`;
  }

  // @ngInject
  public static getCheckboxTemplate($element: any, $attrs: any): string {
    let disabledAttr = "";
    let onChangeAttr = "";

    if ($attrs && $attrs.isDisabled) {
      disabledAttr = " ng-disabled='$ctrl.isDisabled' ";
    }

    if ($attrs && $attrs.onChange) {
      onChangeAttr = " ng-change='$ctrl.onChanged()' ";
    }

    let template = `<div class="c-checkbox">
                <label class="c-label c-checkbox">
                    <input
                        aria-label="{{::$ctrl.label}}"
                        type="checkbox"
                        name="{{::$ctrl.name}}"
                        ${disabledAttr}
                        ${onChangeAttr}
                        ng-model="$ctrl.value"
                        data-bi-name="{{::$ctrl.getBIName()}}"
                        sd-page-action-trigger="{ events:'change', behavior:'Unknown', contentTags:'$ctrl.telemetryData', scenario:'$ctrl.scenario', scenarioStep:'$ctrl.scenarioSteps'}"
                        sd-fill-bi-slot
                        data-bi-id="{{::$ctrl.biId}}">
                    <sd-transclude-replace><span ng-bind="::$ctrl.label"></span></sd-transclude-replace>
                </label>
             </div>`;

    return template;
  }
}

/** Controller for Checkbox group component. */
export class CheckboxGroupController {
  public layout: string;
  public isHorizontal: boolean;

  constructor() {}

  public $onInit() {
    this.refreshView();
  }

  public $onChanges() {
    this.refreshView();
  }

  private refreshView() {
    this.isHorizontal = this.layout && this.layout.toLowerCase() === "horizontal" ? true : false;
  }
}

export const sdCheckbox: ng.IComponentOptions = {
  bindings: <any>new CheckboxBinding(),
  controller: CheckboxController,
  template: CheckboxController.getCheckboxTemplate,
  transclude: true
};
export const sdCheckboxGroup: ng.IComponentOptions = {
  bindings: <any>new CheckboxGroupBinding(),
  controller: CheckboxGroupController,
  template: `<div class="c-checkbox" ng-class="{\'c-group\':$ctrl.isHorizontal}" ng-transclude></div>`,
  transclude: true
};
